module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/shopping_cart_red.d5345952ab.png";